import type {ModalController} from './Modal.controller';

import {MODAL_CLASS_NAMES} from '../../constants';

export class ModalSelectorsManager {
  constructor(private readonly controller: ModalController) {}

  get currentModalId() {
    return `${MODAL_CLASS_NAMES.modal}-${this.controller.id}`;
  }

  get footerContainerId() {
    return `${this.currentModalId} ${MODAL_CLASS_NAMES.footerContainer}`;
  }

  get headerWrapperId() {
    return `${this.currentModalId} ${MODAL_CLASS_NAMES.headerWrapper}`;
  }

  get overlayClassName() {
    return `${this.currentModalId} ${MODAL_CLASS_NAMES.overlay}`;
  }

  get scrollContainerId() {
    return `${this.currentModalId} ${MODAL_CLASS_NAMES.scrollContainer}`;
  }

  buildReactModalClassName(
    className: ModalController.ReactModalClassName = '',
  ): string {
    return `${MODAL_CLASS_NAMES.content} ${MODAL_CLASS_NAMES.content}-${this.controller.id} ${className}`;
  }
}
